import HotelCount from '../../../types/HotelCount';

const useTotalHotelCount = (hotelCount?: HotelCount | number) => {
  let count = 0;
  if (typeof hotelCount === 'number') {
    count = hotelCount;
  } else if (hotelCount?.regions) {
    count = Object.keys((hotelCount as HotelCount)?.regions)
      .filter((region) => region.match(/^[A-Za-z]+$/))
      .reduce((total, region) => total + (hotelCount?.regions[region] || 0), 0);
  }
  return count;
};

export default useTotalHotelCount;
